module.exports = __webpack_public_path__ + "static/img/7.66d2b6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/sp/7.png
// module id = Ujxq
// module chunks = 0